import { MessageList } from './MessageList'
import { MessageCreate } from './MessageCreate'
import { MessageEdit } from './MessageEdit'

export { MessageList, MessageCreate, MessageEdit }


// WEBPACK FOOTER //
// ./src/components/message/index.js